/*
 * @Author: etong
 * @Date: 2021-03-18 14:20:14
 * @LastEditTime: 2021-04-19 20:19:54
 * @LastEditors: your name
 * @Description: 
 * @FilePath: \oak\src\store\getters\common\index.js
 * Think first, Program later
 */
const common = {
    jjflowTrackList: state => state.common.jjflowTrackList, // 审批流数据
    jjflowModalIsShow: state => state.common.jjflowModalIsShow, // 审批流弹窗是否显示
}

export default common